<script>
import * as externalMethods from './methods.js'; 
export default {
   
  data() {
    return {
      buttonID: 0, // 当前悬停的按钮ID
      buttons: [
        { fileName: 'HEC_tutorial.pdf', label: 'DOWNLOAD PDF' },
        { fileName: 'HEC.R', label: 'R CODE' },
        { fileName: 'HEC.py', label: 'PYTHON CODE' },
        { fileName: 'HEC.m', label: 'MATLAB CODE' }
      ]
    };
  },
  methods: {
    ...externalMethods,
  }
};
</script>

<template>

<div> 
        <br>
        <br>
        <!-- <embed id='pdf' type="application/pdf" style="width: 100%; height: 80vh; margin-bottom: 40px" src='/HEC_tutorial.pdf' /> -->
        <div style="width: 100%;font-family:Segoe UI, Times, serif;">
          <p class="font4" style="text-align:left; font-weight:bold">A tutorial on the statistics of hierarchical emergent
            constraint</p>
          <br>
          <p class="font5" style="text-align:left;  font-weight: bold;">Part I. Some Statistical Basis</p>
          <!-- <p class="font4"  style="text-align:left; font-weight: bold;">Some Statistical Basis</p> -->
          <br>
          <p class="font1" style="text-align: left; "><i>This part reviews the statistics necessary to understand the
              hieraichical emergent constraint
              method presented in Bowman et al (https://doi.org/10.1029/2018GL080082).</i></p>
          <br>
          <p class="font1" style="text-align:left; font-weight: bold;"><u>Gaussian distribution:</u></p>
          <p class="font1" style="text-align:left; ">If</p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mtable columnspacing="1em" rowspacing="4pt">
                  <mtr>
                    <mtd>
                      <mi>X</mi>
                    </mtd>
                  </mtr>
                  <mtr>
                    <mtd>
                      <mi>Y</mi>
                    </mtd>
                  </mtr>
                </mtable>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>&#x223C;</mo>
              <mi>N</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mtable columnspacing="1em" rowspacing="4pt">
                  <mtr>
                    <mtd>
                      <mrow data-mjx-texclass="INNER">
                        <mo data-mjx-texclass="OPEN">(</mo>
                        <mtable columnspacing="1em" rowspacing="4pt">
                          <mtr>
                            <mtd>
                              <msub>
                                <mi>&#x3BC;</mi>
                                <mrow>
                                  <mi>X</mi>
                                </mrow>
                              </msub>
                            </mtd>
                          </mtr>
                          <mtr>
                            <mtd>
                              <msub>
                                <mi>&#x3BC;</mi>
                                <mrow>
                                  <mi>Y</mi>
                                </mrow>
                              </msub>
                            </mtd>
                          </mtr>
                        </mtable>
                        <mo data-mjx-texclass="CLOSE">)</mo>
                      </mrow>
                      <mo>,</mo>
                    </mtd>
                    <mtd>
                      <mrow data-mjx-texclass="INNER">
                        <mo data-mjx-texclass="OPEN">(</mo>
                        <mtable columnspacing="1em" rowspacing="4pt">
                          <mtr>
                            <mtd>
                              <msubsup>
                                <mi>&#x3C3;</mi>
                                <mrow>
                                  <mi>X</mi>
                                </mrow>
                                <mrow>
                                  <mn>2</mn>
                                </mrow>
                              </msubsup>
                            </mtd>
                            <mtd>
                              <msub>
                                <mi>&#x3C3;</mi>
                                <mrow>
                                  <mi>X</mi>
                                  <mo>,</mo>
                                  <mi>Y</mi>
                                </mrow>
                              </msub>
                            </mtd>
                          </mtr>
                          <mtr>
                            <mtd>
                              <msub>
                                <mi>&#x3C3;</mi>
                                <mrow>
                                  <mi>X</mi>
                                  <mo>,</mo>
                                  <mi>Y</mi>
                                </mrow>
                              </msub>
                            </mtd>
                            <mtd>
                              <msubsup>
                                <mi>&#x3C3;</mi>
                                <mrow>
                                  <mi>Y</mi>
                                </mrow>
                                <mrow>
                                  <mn>2</mn>
                                </mrow>
                              </msubsup>
                            </mtd>
                          </mtr>
                        </mtable>
                        <mo data-mjx-texclass="CLOSE">)</mo>
                      </mrow>
                    </mtd>
                  </mtr>
                </mtable>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">Then</p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>X</mi>
              <mo>&#x2223;</mo>
              <mi>Y</mi>
              <mo>&#x223C;</mo>
              <mrow>
                <mi mathvariant="normal">N</mi>
              </mrow>
              <mo stretchy="false">(</mo>
              <mrow>
                <mi mathvariant="double-struck">E</mi>
              </mrow>
              <mo stretchy="false">(</mo>
              <mi>X</mi>
              <mo>&#x2223;</mo>
              <mi>Y</mi>
              <mo stretchy="false">)</mo>
              <mo>,</mo>
              <mi>Var</mi>
              <mo data-mjx-texclass="NONE">&#x2061;</mo>
              <mo stretchy="false">(</mo>
              <mi>X</mi>
              <mo>&#x2223;</mo>
              <mi>Y</mi>
              <mo stretchy="false">)</mo>
              <mo stretchy="false">)</mo>
            </math>
          </div>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mrow>
                <mi mathvariant="double-struck">E</mi>
              </mrow>
              <mo stretchy="false">(</mo>
              <mi>X</mi>
              <mo>&#x2223;</mo>
              <mi>Y</mi>
              <mo stretchy="false">)</mo>
              <mo>=</mo>
              <msub>
                <mi>&#x3BC;</mi>
                <mrow>
                  <mi>X</mi>
                </mrow>
              </msub>
              <mo>+</mo>
              <mfrac>
                <msub>
                  <mi>&#x3C3;</mi>
                  <mrow>
                    <mi>X</mi>
                    <mo>,</mo>
                    <mi>Y</mi>
                  </mrow>
                </msub>
                <msubsup>
                  <mi>&#x3C3;</mi>
                  <mrow>
                    <mi>Y</mi>
                  </mrow>
                  <mrow>
                    <mn>2</mn>
                  </mrow>
                </msubsup>
              </mfrac>
              <mo stretchy="false">(</mo>
              <mi>Y</mi>
              <mo>&#x2212;</mo>
              <msub>
                <mi>&#x3BC;</mi>
                <mrow>
                  <mi>Y</mi>
                </mrow>
              </msub>
              <mo stretchy="false">)</mo>
            </math>
          </div>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>X</mi>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <mi>Y</mi>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <mi>X</mi>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <mo>&#x2212;</mo>
              <mfrac>
                <msubsup>
                  <mi>&#x3C3;</mi>
                  <mrow>
                    <mi>X</mi>
                    <mo>,</mo>
                    <mi>Y</mi>
                  </mrow>
                  <mrow>
                    <mn>2</mn>
                  </mrow>
                </msubsup>
                <msubsup>
                  <mi>&#x3C3;</mi>
                  <mrow>
                    <mi>Y</mi>
                  </mrow>
                  <mrow>
                    <mn>2</mn>
                  </mrow>
                </msubsup>
              </mfrac>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">Let <math>
              <msub>
                <mi>K</mi>
                <mrow>
                  <mi>X</mi>
                  <mo>,</mo>
                  <mi>Y</mi>
                </mrow>
              </msub>
              <mo>=</mo>
              <mfrac>
                <msub>
                  <mi>&#x3C3;</mi>
                  <mrow>
                    <mi>X</mi>
                    <mo>,</mo>
                    <mi>Y</mi>
                  </mrow>
                </msub>
                <msubsup>
                  <mi>&#x3C3;</mi>
                  <mrow>
                    <mi>Y</mi>
                  </mrow>
                  <mrow>
                    <mn>2</mn>
                  </mrow>
                </msubsup>
              </mfrac>
            </math>
            ,the mean and the variance of the conditional distribution can be expressed as</p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>X</mi>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <mi>Y</mi>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msub>
                <mi>&#x3BC;</mi>
                <mrow>
                  <mi>X</mi>
                </mrow>
              </msub>
              <mo>&#x2212;</mo>
              <msub>
                <mi>K</mi>
                <mrow>
                  <mi>X</mi>
                  <mo>,</mo>
                  <mi>Y</mi>
                </mrow>
              </msub>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>Y</mi>
                <mo>&#x2212;</mo>
                <msub>
                  <mi>&#x3BC;</mi>
                  <mrow>
                    <mi>Y</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>X</mi>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <mi>Y</mi>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <mi>X</mi>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <mo>&#x2212;</mo>
              <msub>
                <mi>K</mi>
                <mrow>
                  <mi>X</mi>
                  <mo>,</mo>
                  <msup>
                    <mi>Y</mi>
                    <mrow>
                      <mi>&#x3C3;</mi>
                    </mrow>
                  </msup>
                  <mi>X</mi>
                  <mo>,</mo>
                  <mi>Y</mi>
                </mrow>
              </msub>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; font-weight: bold;"><u>Variance and covariance:</u></p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>a</mi>
                <mi>X</mi>
                <mo>+</mo>
                <mi>b</mi>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msup>
                <mi>a</mi>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msup>
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>X</mi>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>a</mi>
                <mi>X</mi>
                <mo>+</mo>
                <mi>b</mi>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <mi>Y</mi>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msup>
                <mi>a</mi>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msup>
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>X</mi>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <mi>Y</mi>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>C</mi>
              <mi>o</mi>
              <mi>v</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>X</mi>
                <mo>+</mo>
                <mi>Y</mi>
                <mo>,</mo>
                <mi>Z</mi>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <mi>C</mi>
              <mi>o</mi>
              <mi>v</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>X</mi>
                <mo>,</mo>
                <mi>Z</mi>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>+</mo>
              <mi>C</mi>
              <mi>o</mi>
              <mi>v</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>Y</mi>
                <mo>,</mo>
                <mi>Z</mi>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; font-weight: bold;"><u>The law of total expectation:</u></p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>X</mi>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>E</mi>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mi>X</mi>
                  <mrow>
                    <mo stretchy="false">|</mo>
                  </mrow>
                  <mi>Y</mi>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>X</mi>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <mi>Y</mi>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>E</mi>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mi>X</mi>
                  <mrow>
                    <mo stretchy="false">|</mo>
                  </mrow>
                  <mi>Y</mi>
                  <mo>,</mo>
                  <mi>Z</mi>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <mi>Y</mi>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; font-weight: bold;"><u>The law of total variance:</u></p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>X</mi>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>V</mi>
                <mi>a</mi>
                <mi>r</mi>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mi>X</mi>
                  <mrow>
                    <mo stretchy="false">|</mo>
                  </mrow>
                  <mi>Y</mi>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>+</mo>
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>E</mi>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mi>X</mi>
                  <mrow>
                    <mo stretchy="false">|</mo>
                  </mrow>
                  <mi>Y</mi>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>X</mi>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <mi>Y</mi>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>V</mi>
                <mi>a</mi>
                <mi>r</mi>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mi>X</mi>
                  <mrow>
                    <mo stretchy="false">|</mo>
                  </mrow>
                  <mi>Y</mi>
                  <mo>,</mo>
                  <mi>Z</mi>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <mi>Y</mi>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>+</mo>
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>E</mi>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mi>X</mi>
                  <mrow>
                    <mo stretchy="false">|</mo>
                  </mrow>
                  <mi>Y</mi>
                  <mo>,</mo>
                  <mi>Z</mi>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <mi>Y</mi>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <br>
          <p class="font5" style="text-align:left;  font-weight: bold;">Part II. Hierarchical Emergent Constraint</p>
          <!-- <p class="font4"  style="text-align:left; font-weight: bold;">Hierarchical Emergent Constraint</p> -->
          <br>
          <p class="font1" style="text-align:left; ">The hierarchical emergent constraint (HEC) method involves three
            random variables:</p>
          <ul>
            <li>
              <p class="font1" style="text-align:left; ">A random variable describing current climate state in climate
                models <math>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>&#x223C;</mo>
                  <mi>N</mi>
                  <mrow data-mjx-texclass="INNER">
                    <mo data-mjx-texclass="OPEN">(</mo>
                    <msub>
                      <mi>&#x3BC;</mi>
                      <mrow>
                        <msub>
                          <mi>X</mi>
                          <mrow>
                            <mi>t</mi>
                          </mrow>
                        </msub>
                      </mrow>
                    </msub>
                    <mo>,</mo>
                    <msubsup>
                      <mi>&#x3C3;</mi>
                      <mrow>
                        <msub>
                          <mi>X</mi>
                          <mrow>
                            <mi>t</mi>
                          </mrow>
                        </msub>
                      </mrow>
                      <mrow>
                        <mn>2</mn>
                      </mrow>
                    </msubsup>
                    <mo data-mjx-texclass="CLOSE">)</mo>
                  </mrow>
                </math>
              </p>
            </li>
            <li>
              <p class="font1" style="text-align:left; ">A random variable describing future climate state in climate
                models <math>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>&#x223C;</mo>
                  <mi>N</mi>
                  <mrow data-mjx-texclass="INNER">
                    <mo data-mjx-texclass="OPEN">(</mo>
                    <msub>
                      <mi>&#x3BC;</mi>
                      <mrow>
                        <msub>
                          <mi>X</mi>
                          <mrow>
                            <mi>t</mi>
                            <mo>+</mo>
                            <mi>&#x3B4;</mi>
                            <mi>t</mi>
                          </mrow>
                        </msub>
                      </mrow>
                    </msub>
                    <mo>,</mo>
                    <msubsup>
                      <mi>&#x3C3;</mi>
                      <mrow>
                        <msub>
                          <mi>X</mi>
                          <mrow>
                            <mi>t</mi>
                            <mo>+</mo>
                            <mi>&#x3B4;</mi>
                            <mi>t</mi>
                          </mrow>
                        </msub>
                      </mrow>
                      <mrow>
                        <mn>2</mn>
                      </mrow>
                    </msubsup>
                    <mo data-mjx-texclass="CLOSE">)</mo>
                  </mrow>
                </math>
              </p>
            </li>
            <li>
              <p class="font1" style="text-align:left; ">A random variable describing observation of the current climate
                state <math>
                  <msub>
                    <mi>Y</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>=</mo>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>+</mo>
                  <msub>
                    <mi>&#x3B5;</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </math>
                ,where <math>
                  <msub>
                    <mi>&#x3B5;</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>&#x223C;</mo>
                  <mi>N</mi>
                  <mrow data-mjx-texclass="INNER">
                    <mo data-mjx-texclass="OPEN">(</mo>
                    <mn>0</mn>
                    <mo>,</mo>
                    <msubsup>
                      <mi>&#x3C3;</mi>
                      <mrow>
                        <msub>
                          <mi>&#x3B5;</mi>
                          <mrow>
                            <mi>t</mi>
                          </mrow>
                        </msub>
                      </mrow>
                      <mrow>
                        <mn>2</mn>
                      </mrow>
                    </msubsup>
                    <mo data-mjx-texclass="CLOSE">)</mo>
                  </mrow>
                </math>
                models observation uncertainty and is <strong style="font-weight: bold;">independent</strong> to <math>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </math>
              </p>
            </li>
          </ul>
          <p class="font1" style="text-align:left; ">By definition, <math>
              <msub>
                <mi>Y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math> conforms to a Gaussian with</p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <msub>
                <mi>&#x3BC;</mi>
                <mrow>
                  <msub>
                    <mi>Y</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
              <mo>=</mo>
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo>+</mo>
                <msub>
                  <mi>&#x3B5;</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msub>
                <mi>&#x3BC;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
            </math>
          </div>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>Y</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <mo>=</mo>
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>Y</mi>
                  <mi>t</mi>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mi>t</mi>
                </msub>
                <mo>+</mo>
                <msub>
                  <mi>&#x3B5;</mi>
                  <mi>t</mi>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mi>t</mi>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>+</mo>
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>&#x3B5;</mi>
                  <mi>t</mi>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <mo>+</mo>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>&#x3B5;</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">Note that explicitly acounting for uncertainty of the observational
            constraint reflects the primary
            difference between HEC and the emergent constraint method based on the conventional least
            squares regression. The latter assumes that <math>
              <msub>
                <mi>Y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math> and <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>
            are exchangable and thus identical in
            distribution <math>
              <msub>
                <mi>Y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mover>
                <mo>=</mo>
                <mi>d</mi>
              </mover>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>
            .</p>
          <br>
          <p class="font2" style="text-align:left;  font-weight: bold; text-underline-position: under;"><u>The
              conditional distribution <i>X</i><sub><i>t</i></sub>|<i>Y</i><sub><i>t</i></sub></u></p>
          <br>
          <p class="font1" style="text-align:left; ">As <math>
              <msub>
                <mi>Y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math> and <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math> both conform to Gaussian, their joint distribution conforms to Guassian as well, i.e.,</p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mtable columnspacing="1em" rowspacing="4pt">
                  <mtr>
                    <mtd>
                      <msub>
                        <mi>X</mi>
                        <mrow>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mtd>
                  </mtr>
                  <mtr>
                    <mtd>
                      <msub>
                        <mi>Y</mi>
                        <mrow>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mtd>
                  </mtr>
                </mtable>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>&#x223C;</mo>
              <mi>N</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mtable columnspacing="1em" rowspacing="4pt">
                    <mtr>
                      <mtd>
                        <msub>
                          <mi>&#x3BC;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                        </msub>
                      </mtd>
                    </mtr>
                    <mtr>
                      <mtd>
                        <msub>
                          <mi>&#x3BC;</mi>
                          <mrow>
                            <msub>
                              <mi>Y</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                        </msub>
                      </mtd>
                    </mtr>
                  </mtable>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo>,</mo>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mtable columnspacing="1em" rowspacing="4pt">
                    <mtr>
                      <mtd>
                        <msubsup>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                          <mrow>
                            <mn>2</mn>
                          </mrow>
                        </msubsup>
                      </mtd>
                      <mtd>
                        <mi>C</mi>
                        <mi>o</mi>
                        <mi>v</mi>
                        <mrow data-mjx-texclass="INNER">
                          <mo data-mjx-texclass="OPEN">(</mo>
                          <msub>
                            <mi>X</mi>
                            <mrow>
                              <mi>t</mi>
                            </mrow>
                          </msub>
                          <mo>,</mo>
                          <msub>
                            <mi>Y</mi>
                            <mrow>
                              <mi>t</mi>
                            </mrow>
                          </msub>
                          <mo data-mjx-texclass="CLOSE">)</mo>
                        </mrow>
                      </mtd>
                    </mtr>
                    <mtr>
                      <mtd>
                        <mi>C</mi>
                        <mi>o</mi>
                        <mi>v</mi>
                        <mrow data-mjx-texclass="INNER">
                          <mo data-mjx-texclass="OPEN">(</mo>
                          <msub>
                            <mi>Y</mi>
                            <mrow>
                              <mi>t</mi>
                            </mrow>
                          </msub>
                          <mo>,</mo>
                          <msub>
                            <mi>X</mi>
                            <mrow>
                              <mi>t</mi>
                            </mrow>
                          </msub>
                          <mo data-mjx-texclass="CLOSE">)</mo>
                        </mrow>
                      </mtd>
                      <mtd>
                        <msubsup>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>Y</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                          <mrow>
                            <mn>2</mn>
                          </mrow>
                        </msubsup>
                      </mtd>
                    </mtr>
                  </mtable>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">According to the relation <math>
              <msub>
                <mi>Y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mo>=</mo>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mo>+</mo>
              <msub>
                <mi>&#x3B5;</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>, it follows that</p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <msub>
                <mi>&#x3BC;</mi>
                <mrow>
                  <msub>
                    <mi>Y</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
              <mo>=</mo>
              <msub>
                <mi>&#x3BC;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
            </math>
          </div>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>Y</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <mo>=</mo>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <mo>+</mo>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>&#x3B5;</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
            </math>
          </div>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>C</mi>
              <mi>o</mi>
              <mi>v</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo>,</mo>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <mi>C</mi>
              <mi>o</mi>
              <mi>v</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo>,</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo>+</mo>
                <msub>
                  <mi>&#x3B5;</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <mi>C</mi>
              <mi>o</mi>
              <mi>v</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo>,</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>+</mo>
              <mi>C</mi>
              <mi>o</mi>
              <mi>v</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo>,</mo>
                <msub>
                  <mi>&#x3B5;</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">Thus, the joint distribution of <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math> and <math>
              <msub>
                <mi>Y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math> can be written as follows</p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mtable columnspacing="1em" rowspacing="4pt">
                  <mtr>
                    <mtd>
                      <msub>
                        <mi>X</mi>
                        <mrow>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mtd>
                  </mtr>
                  <mtr>
                    <mtd>
                      <msub>
                        <mi>Y</mi>
                        <mrow>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mtd>
                  </mtr>
                </mtable>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>&#x223C;</mo>
              <mi>N</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mtable columnspacing="1em" rowspacing="4pt">
                    <mtr>
                      <mtd>
                        <msub>
                          <mi>&#x3BC;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                        </msub>
                      </mtd>
                    </mtr>
                    <mtr>
                      <mtd>
                        <msub>
                          <mi>&#x3BC;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                        </msub>
                      </mtd>
                    </mtr>
                  </mtable>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo>,</mo>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mtable columnspacing="1em" rowspacing="4pt">
                    <mtr>
                      <mtd>
                        <msubsup>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                          <mrow>
                            <mn>2</mn>
                          </mrow>
                        </msubsup>
                      </mtd>
                      <mtd>
                        <msubsup>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                          <mrow>
                            <mn>2</mn>
                          </mrow>
                        </msubsup>
                      </mtd>
                    </mtr>
                    <mtr>
                      <mtd>
                        <msubsup>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                          <mrow>
                            <mn>2</mn>
                          </mrow>
                        </msubsup>
                      </mtd>
                      <mtd>
                        <msubsup>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                          <mrow>
                            <mn>2</mn>
                          </mrow>
                        </msubsup>
                        <mo>+</mo>
                        <msubsup>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>&#x3B5;</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                          <mrow>
                            <mn>2</mn>
                          </mrow>
                        </msubsup>
                      </mtd>
                    </mtr>
                  </mtable>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">With this joint distribution, the condition distribution <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mrow>
                <mo stretchy="false">|</mo>
              </mrow>
              <msub>
                <mi>Y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>can be obtained by applying the
            formula of conditional mean and variance of a joint Guassian distribution, as follows</p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mrow>
                <mo stretchy="false">|</mo>
              </mrow>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mo>&#x223C;</mo>
              <mi>N</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>&#x3BC;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                </msub>
                <mo>+</mo>
                <msub>
                  <mi>K</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                    <mo>,</mo>
                    <msub>
                      <mi>Y</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                </msub>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mi>Y</mi>
                  <mo>&#x2212;</mo>
                  <msub>
                    <mi>&#x3BC;</mi>
                    <mrow>
                      <msub>
                        <mi>X</mi>
                        <mrow>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mrow>
                  </msub>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo>,</mo>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mn>1</mn>
                  <mo>&#x2212;</mo>
                  <msub>
                    <mi>K</mi>
                    <mrow>
                      <msub>
                        <mi>X</mi>
                        <mrow>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                      <mo>,</mo>
                      <msub>
                        <mi>Y</mi>
                        <mrow>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mrow>
                  </msub>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <msubsup>
                  <mi>&#x3C3;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                  <mrow>
                    <mn>2</mn>
                  </mrow>
                </msubsup>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <msub>
                <mi>K</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>,</mo>
                  <msub>
                    <mi>Y</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
              <mo>=</mo>
              <mfrac>
                <msubsup>
                  <mi>&#x3C3;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                  <mrow>
                    <mn>2</mn>
                  </mrow>
                </msubsup>
                <mrow>
                  <msubsup>
                    <mi>&#x3C3;</mi>
                    <mrow>
                      <msub>
                        <mi>X</mi>
                        <mrow>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mrow>
                    <mrow>
                      <mn>2</mn>
                    </mrow>
                  </msubsup>
                  <mo>+</mo>
                  <msubsup>
                    <mi>&#x3C3;</mi>
                    <mrow>
                      <msub>
                        <mi>&#x3B5;</mi>
                        <mrow>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mrow>
                    <mrow>
                      <mn>2</mn>
                    </mrow>
                  </msubsup>
                </mrow>
              </mfrac>
            </math>
          </div>
          <br>
          <p class="font2" style="text-align:left;  font-weight: bold;text-underline-position: under;"><u>The
              conditional distribution <i>X</i><sub><i>t+δt</i></sub>|<i>X</i><sub><i>t</i></sub></u></p>
          <br>
          <p class="font1" style="text-align:left; ">Likewise, the future climate state <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                  <mo>+</mo>
                  <mi>&#x3B4;</mi>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math> and the current climate state <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math> are also jointly Gaussian</p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mtable columnspacing="1em" rowspacing="4pt">
                  <mtr>
                    <mtd>
                      <msub>
                        <mi>X</mi>
                        <mrow>
                          <mi>t</mi>
                          <mo>+</mo>
                          <mi>&#x3B4;</mi>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mtd>
                  </mtr>
                  <mtr>
                    <mtd>
                      <msub>
                        <mi>X</mi>
                        <mrow>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mtd>
                  </mtr>
                </mtable>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>&#x223C;</mo>
              <mi>N</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mtable columnspacing="1em" rowspacing="4pt">
                    <mtr>
                      <mtd>
                        <msub>
                          <mi>&#x3BC;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                                <mo>+</mo>
                                <mi>&#x3B4;</mi>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                        </msub>
                      </mtd>
                    </mtr>
                    <mtr>
                      <mtd>
                        <msub>
                          <mi>&#x3BC;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                        </msub>
                      </mtd>
                    </mtr>
                  </mtable>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo>,</mo>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mtable columnspacing="1em" rowspacing="4pt">
                    <mtr>
                      <mtd>
                        <msubsup>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                                <mo>+</mo>
                                <mi>&#x3B4;</mi>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                          <mrow>
                            <mn>2</mn>
                          </mrow>
                        </msubsup>
                      </mtd>
                      <mtd>
                        <msub>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                                <mo>+</mo>
                                <mi>&#x3B4;</mi>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                            <mo>,</mo>
                            <msub>
                              <mi>X</mi>
                              <mi>t</mi>
                            </msub>
                          </mrow>
                        </msub>
                      </mtd>
                    </mtr>
                    <mtr>
                      <mtd>
                        <msub>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mi>t</mi>
                            </msub>
                            <mo>,</mo>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                                <mo>+</mo>
                                <mi>&#x3B4;</mi>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                        </msub>
                      </mtd>
                      <mtd>
                        <msubsup>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                          <mrow>
                            <mn>2</mn>
                          </mrow>
                        </msubsup>
                      </mtd>
                    </mtr>
                  </mtable>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">Expressing the covariance between <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                  <mo>+</mo>
                  <mi>&#x3B4;</mi>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math> and <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>
            as a function of their correlation coefficeint <i>ρ</i>
            yields
          </p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mtable columnspacing="1em" rowspacing="4pt">
                  <mtr>
                    <mtd>
                      <msub>
                        <mi>X</mi>
                        <mrow>
                          <mi>t</mi>
                          <mo>+</mo>
                          <mi>&#x3B4;</mi>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mtd>
                  </mtr>
                  <mtr>
                    <mtd>
                      <msub>
                        <mi>X</mi>
                        <mrow>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mtd>
                  </mtr>
                </mtable>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>&#x223C;</mo>
              <mi>N</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mtable columnspacing="1em" rowspacing="4pt">
                    <mtr>
                      <mtd>
                        <msub>
                          <mi>&#x3BC;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                                <mo>+</mo>
                                <mi>&#x3B4;</mi>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                        </msub>
                      </mtd>
                    </mtr>
                    <mtr>
                      <mtd>
                        <msub>
                          <mi>&#x3BC;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                        </msub>
                      </mtd>
                    </mtr>
                  </mtable>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo>,</mo>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mtable columnspacing="1em" rowspacing="4pt">
                    <mtr>
                      <mtd>
                        <msubsup>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                                <mo>+</mo>
                                <mi>&#x3B4;</mi>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                          <mrow>
                            <mn>2</mn>
                          </mrow>
                        </msubsup>
                      </mtd>
                      <mtd>
                        <mi>&#x3C1;</mi>
                        <msub>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                                <mo>+</mo>
                                <mi>&#x3B4;</mi>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                        </msub>
                        <msub>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                        </msub>
                      </mtd>
                    </mtr>
                    <mtr>
                      <mtd>
                        <mi>&#x3C1;</mi>
                        <msub>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                                <mo>+</mo>
                                <mi>&#x3B4;</mi>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                        </msub>
                        <msub>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                        </msub>
                      </mtd>
                      <mtd>
                        <msubsup>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                          <mrow>
                            <mn>2</mn>
                          </mrow>
                        </msubsup>
                      </mtd>
                    </mtr>
                  </mtable>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">Then, the conditional distribution <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                  <mo>+</mo>
                  <mi>&#x3B4;</mi>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mrow>
                <mo stretchy="false">|</mo>
              </mrow>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>
            can be readliy obtained, that is,
          </p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                  <mo>+</mo>
                  <mi>&#x3B4;</mi>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mrow>
                <mo stretchy="false">|</mo>
              </mrow>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mo>&#x223C;</mo>
              <mi>N</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>&#x3BC;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                        <mo>+</mo>
                        <mi>&#x3B4;</mi>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                </msub>
                <mo>+</mo>
                <msub>
                  <mi>K</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                        <mo>+</mo>
                        <mi>&#x3B4;</mi>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                    <mo>,</mo>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                </msub>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>&#x2212;</mo>
                  <msub>
                    <mi>&#x3BC;</mi>
                    <mrow>
                      <msub>
                        <mi>X</mi>
                        <mrow>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mrow>
                  </msub>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo>,</mo>
                <msubsup>
                  <mi>&#x3C3;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                        <mo>+</mo>
                        <mi>&#x3B4;</mi>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                  <mrow>
                    <mn>2</mn>
                  </mrow>
                </msubsup>
                <mo>&#x2212;</mo>
                <msubsup>
                  <mi>K</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                        <mo>+</mo>
                        <mi>&#x3B4;</mi>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                    <mo>,</mo>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                  <mrow>
                    <mn>2</mn>
                  </mrow>
                </msubsup>
                <msubsup>
                  <mi>&#x3C3;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                  <mrow>
                    <mn>2</mn>
                  </mrow>
                </msubsup>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <msub>
                <mi>K</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>,</mo>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
              <mo>=</mo>
              <mfrac>
                <mrow>
                  <mi>&#x3C1;</mi>
                  <msub>
                    <mi>&#x3C3;</mi>
                    <mrow>
                      <msub>
                        <mi>X</mi>
                        <mrow>
                          <mi>t</mi>
                          <mo>+</mo>
                          <mi>&#x3B4;</mi>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mrow>
                  </msub>
                  <msub>
                    <mi>&#x3C3;</mi>
                    <mrow>
                      <msub>
                        <mi>X</mi>
                        <mrow>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mrow>
                  </msub>
                </mrow>
                <msubsup>
                  <mi>&#x3C3;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                  <mrow>
                    <mn>2</mn>
                  </mrow>
                </msubsup>
              </mfrac>
              <mo>=</mo>
              <mfrac>
                <mrow>
                  <mi>&#x3C1;</mi>
                  <msub>
                    <mi>&#x3C3;</mi>
                    <mrow>
                      <msub>
                        <mi>X</mi>
                        <mrow>
                          <mi>t</mi>
                          <mo>+</mo>
                          <mi>&#x3B4;</mi>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mrow>
                  </msub>
                </mrow>
                <msub>
                  <mi>&#x3C3;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                </msub>
              </mfrac>
            </math>
          </div>
          <br>
          <p class="font2" style="text-align:left;  font-weight: bold;text-underline-position: under;"><u>The
              conditional distribution <i>X</i><sub><i>t+δt</i></sub>|<i>Y</i><sub><i>t</i></sub></u></p>
          <br>
          <p class="font1" style="text-align:left; ">Under the Guassian assumption for both <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                  <mo>+</mo>
                  <mi>&#x3B4;</mi>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>
            and <math>
              <msub>
                <mi>Y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>, the conditional distribution <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                  <mo>+</mo>
                  <mi>&#x3B4;</mi>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mrow>
                <mo stretchy="false">|</mo>
              </mrow>
              <msub>
                <mi>Y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>
            conforms to Gaussian as well. The idea of the hirarchical emergent constraint method is to constrain
            the modeld future climate <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                  <mo>+</mo>
                  <mi>&#x3B4;</mi>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>
            by hirarchically imposing the modeled current climate state <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>
            and the observation <math>
              <msub>
                <mi>Y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>
            as constraint conditions, it is natural to derive <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                  <mo>+</mo>
                  <mi>&#x3B4;</mi>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mrow>
                <mo stretchy="false">|</mo>
              </mrow>
              <msub>
                <mi>Y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>
            by introducing the
            current climate state <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>
            as an intermediate conditional variable.</p>
          <p class="font1" style="text-align:left; ">Based on the law of total expectation, <math>
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                    <mo>+</mo>
                    <mi>&#x3B4;</mi>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
            can be inferred as folows</p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                    <mo>+</mo>
                    <mi>&#x3B4;</mi>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>E</mi>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mrow>
                    <mo stretchy="false">|</mo>
                  </mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>,</mo>
                  <msub>
                    <mi>Y</mi>
                    <mi>t</mi>
                  </msub>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">As the distribution of future climate <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                  <mo>+</mo>
                  <mi>&#x3B4;</mi>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math> is independent of the observation <math>
              <msub>
                <mi>Y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math> given <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>
            , the right-hand-side of the above equation simplifies to</p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                    <mo>+</mo>
                    <mi>&#x3B4;</mi>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>E</mi>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mrow>
                    <mo stretchy="false">|</mo>
                  </mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">Substituting <math>
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                    <mo>+</mo>
                    <mi>&#x3B4;</mi>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msub>
                <mi>&#x3BC;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
              <mo>+</mo>
              <msub>
                <mi>K</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>,</mo>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mi>t</mi>
                </msub>
                <mo>&#x2212;</mo>
                <msub>
                  <mi>&#x3BC;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
            into the above equation yields
          </p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                    <mo>+</mo>
                    <mi>&#x3B4;</mi>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msub>
                <mi>&#x3BC;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
              <mo>+</mo>
              <msub>
                <mi>K</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>,</mo>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>E</mi>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mrow>
                    <mo stretchy="false">|</mo>
                  </mrow>
                  <msub>
                    <mi>Y</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo>&#x2212;</mo>
                <msub>
                  <mi>&#x3BC;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">Recall that <math>
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msub>
                <mi>&#x3BC;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
              <mo>+</mo>
              <msub>
                <mi>K</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>,</mo>
                  <msub>
                    <mi>Y</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>Y</mi>
                <mo>&#x2212;</mo>
                <msub>
                  <mi>&#x3BC;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>,
            then

          </p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                    <mo>+</mo>
                    <mi>&#x3B4;</mi>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msub>
                <mi>&#x3BC;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
              <mo>+</mo>
              <msub>
                <mi>K</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>,</mo>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
              <msub>
                <mi>K</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>,</mo>
                  <msub>
                    <mi>Y</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>Y</mi>
                <mo>&#x2212;</mo>
                <msub>
                  <mi>&#x3BC;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">or equivalently,

          </p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                    <mo>+</mo>
                    <mi>&#x3B4;</mi>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msub>
                <mi>&#x3BC;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
              <mo>+</mo>
              <mfrac>
                <mrow>
                  <mi>&#x3C1;</mi>
                  <msub>
                    <mi>&#x3C3;</mi>
                    <mrow>
                      <msub>
                        <mi>X</mi>
                        <mrow>
                          <mi>t</mi>
                          <mo>+</mo>
                          <mi>&#x3B4;</mi>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mrow>
                  </msub>
                  <msub>
                    <mi>&#x3C3;</mi>
                    <mrow>
                      <msub>
                        <mi>X</mi>
                        <mrow>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <msubsup>
                    <mi>&#x3C3;</mi>
                    <mrow>
                      <msub>
                        <mi>X</mi>
                        <mrow>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mrow>
                    <mrow>
                      <mn>2</mn>
                    </mrow>
                  </msubsup>
                  <mo>+</mo>
                  <msubsup>
                    <mi>&#x3C3;</mi>
                    <mrow>
                      <msub>
                        <mi>&#x3B5;</mi>
                        <mrow>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mrow>
                    <mrow>
                      <mn>2</mn>
                    </mrow>
                  </msubsup>
                </mrow>
              </mfrac>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>Y</mi>
                <mo>&#x2212;</mo>
                <msub>
                  <mi>&#x3BC;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">To derive the variance of <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                  <mo>+</mo>
                  <mi>&#x3B4;</mi>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mrow>
                <mo stretchy="false">|</mo>
              </mrow>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>,
            the law of total variance is employed:
          </p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                    <mo>+</mo>
                    <mi>&#x3B4;</mi>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>V</mi>
                <mi>a</mi>
                <mi>r</mi>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mrow>
                    <mo stretchy="false">|</mo>
                  </mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>,</mo>
                  <msub>
                    <mi>Y</mi>
                    <mi>t</mi>
                  </msub>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>+</mo>
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>E</mi>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mrow>
                    <mo stretchy="false">|</mo>
                  </mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>,</mo>
                  <msub>
                    <mi>Y</mi>
                    <mi>t</mi>
                  </msub>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">Again according to the fact that the distribution of future climate
            <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                  <mo>+</mo>
                  <mi>&#x3B4;</mi>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math> is independent of the
            observation <math>
              <msub>
                <mi>Y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math> given the modeled current climate state <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>, the above equation reduces to
          </p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                    <mo>+</mo>
                    <mi>&#x3B4;</mi>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>V</mi>
                <mi>a</mi>
                <mi>r</mi>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mrow>
                    <mo stretchy="false">|</mo>
                  </mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>+</mo>
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mi>E</mi>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mrow>
                    <mo stretchy="false">|</mo>
                  </mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">Substituting <math>
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                    <mo>+</mo>
                    <mi>&#x3B4;</mi>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <mo>&#x2212;</mo>
              <msubsup>
                <mi>K</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>,</mo>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
            </math>
            and <math>
              <mi>E</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                    <mo>+</mo>
                    <mi>&#x3B4;</mi>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msub>
                <mi>&#x3BC;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
              <mo>+</mo>
              <msub>
                <mi>K</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>,</mo>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mi>t</mi>
                </msub>
                <mo>&#x2212;</mo>
                <msub>
                  <mi>&#x3BC;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
            into the above equation leads to
          </p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                    <mo>+</mo>
                    <mi>&#x3B4;</mi>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <mo>&#x2212;</mo>
              <msubsup>
                <mi>K</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>,</mo>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <mo>+</mo>
              <msubsup>
                <mi>K</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>,</mo>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">Substituting <math>
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <mo>&#x2212;</mo>
              <msub>
                <mi>K</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>,</mo>
                  <msub>
                    <mi>Y</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
            </math>
            into the above equation follows
          </p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                    <mo>+</mo>
                    <mi>&#x3B4;</mi>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <mo>&#x2212;</mo>
              <msubsup>
                <mi>K</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>,</mo>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <msub>
                <mi>K</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>,</mo>
                  <msub>
                    <mi>Y</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">or equivalently,

          </p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <mi>V</mi>
              <mi>a</mi>
              <mi>r</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>X</mi>
                  <mrow>
                    <mi>t</mi>
                    <mo>+</mo>
                    <mi>&#x3B4;</mi>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mrow>
                  <mo stretchy="false">|</mo>
                </mrow>
                <msub>
                  <mi>Y</mi>
                  <mrow>
                    <mi>t</mi>
                  </mrow>
                </msub>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
              <mo>=</mo>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mn>1</mn>
                <mo>&#x2212;</mo>
                <mfrac>
                  <msup>
                    <mi>&#x3C1;</mi>
                    <mrow>
                      <mn>2</mn>
                    </mrow>
                  </msup>
                  <mrow>
                    <mn>1</mn>
                    <mo>+</mo>
                    <mfrac>
                      <msubsup>
                        <mi>&#x3C3;</mi>
                        <mrow>
                          <msub>
                            <mi>&#x3B5;</mi>
                            <mrow>
                              <mi>t</mi>
                            </mrow>
                          </msub>
                        </mrow>
                        <mrow>
                          <mn>2</mn>
                        </mrow>
                      </msubsup>
                      <msubsup>
                        <mi>&#x3C3;</mi>
                        <mrow>
                          <msub>
                            <mi>X</mi>
                            <mrow>
                              <mi>t</mi>
                            </mrow>
                          </msub>
                        </mrow>
                        <mrow>
                          <mn>2</mn>
                        </mrow>
                      </msubsup>
                    </mfrac>
                  </mrow>
                </mfrac>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">Wiht the mean and variance derived above, the condition
            distribution <math>
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                  <mo>+</mo>
                  <mi>&#x3B4;</mi>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mrow>
                <mo stretchy="false">|</mo>
              </mrow>
              <msub>
                <mi>Y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>
            is fully determined as follows,

          </p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                  <mo>+</mo>
                  <mi>&#x3B4;</mi>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mrow>
                <mo stretchy="false">|</mo>
              </mrow>
              <msub>
                <mi>Y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mo>&#x223C;</mo>
              <mi>N</mi>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>&#x3BC;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                        <mo>+</mo>
                        <mi>&#x3B4;</mi>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                </msub>
                <mo>+</mo>
                <msub>
                  <mi>K</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                        <mo>+</mo>
                        <mi>&#x3B4;</mi>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                    <mo>,</mo>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                </msub>
                <msub>
                  <mi>K</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                    <mo>,</mo>
                    <msub>
                      <mi>Y</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                </msub>
                <mo stretchy="false">(</mo>
                <mi>Y</mi>
                <mo>&#x2212;</mo>
                <msub>
                  <mi>&#x3BC;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                </msub>
                <mo stretchy="false">)</mo>
                <mo>,</mo>
                <msubsup>
                  <mi>&#x3C3;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                        <mo>+</mo>
                        <mi>&#x3B4;</mi>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                  <mrow>
                    <mn>2</mn>
                  </mrow>
                </msubsup>
                <mo>&#x2212;</mo>
                <msubsup>
                  <mi>K</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                        <mo>+</mo>
                        <mi>&#x3B4;</mi>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                    <mo>,</mo>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                  <mrow>
                    <mn>2</mn>
                  </mrow>
                </msubsup>
                <msub>
                  <mi>K</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                    <mo>,</mo>
                    <msub>
                      <mi>Y</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                </msub>
                <msubsup>
                  <mi>&#x3C3;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                  <mrow>
                    <mn>2</mn>
                  </mrow>
                </msubsup>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">or equivalently,
          </p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                  <mo>+</mo>
                  <mi>&#x3B4;</mi>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mrow>
                <mo stretchy="false">|</mo>
              </mrow>
              <msub>
                <mi>Y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mo>&#x223C;</mo>
              <mrow>
                <mi mathvariant="normal">N</mi>
              </mrow>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>&#x3BC;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                        <mo>+</mo>
                        <mi>&#x3B4;</mi>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                </msub>
                <mo>+</mo>
                <mfrac>
                  <mrow>
                    <mi>&#x3C1;</mi>
                    <msub>
                      <mi>&#x3C3;</mi>
                      <mrow>
                        <msub>
                          <mi>X</mi>
                          <mrow>
                            <mi>t</mi>
                            <mo>+</mo>
                            <mi>&#x3B4;</mi>
                            <mi>t</mi>
                          </mrow>
                        </msub>
                      </mrow>
                    </msub>
                    <msub>
                      <mi>&#x3C3;</mi>
                      <mrow>
                        <msub>
                          <mi>X</mi>
                          <mrow>
                            <mi>t</mi>
                          </mrow>
                        </msub>
                      </mrow>
                    </msub>
                  </mrow>
                  <mrow>
                    <msubsup>
                      <mi>&#x3C3;</mi>
                      <mrow>
                        <msub>
                          <mi>X</mi>
                          <mrow>
                            <mi>t</mi>
                          </mrow>
                        </msub>
                      </mrow>
                      <mrow>
                        <mn>2</mn>
                      </mrow>
                    </msubsup>
                    <mo>+</mo>
                    <msubsup>
                      <mi>&#x3C3;</mi>
                      <mrow>
                        <msub>
                          <mi>&#x3B5;</mi>
                          <mrow>
                            <mi>t</mi>
                          </mrow>
                        </msub>
                      </mrow>
                      <mrow>
                        <mn>2</mn>
                      </mrow>
                    </msubsup>
                  </mrow>
                </mfrac>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mi>Y</mi>
                  <mo>&#x2212;</mo>
                  <msub>
                    <mi>&#x3BC;</mi>
                    <mrow>
                      <msub>
                        <mi>X</mi>
                        <mrow>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mrow>
                  </msub>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo>,</mo>
                <msubsup>
                  <mi>&#x3C3;</mi>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                        <mo>+</mo>
                        <mi>&#x3B4;</mi>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                  <mrow>
                    <mn>2</mn>
                  </mrow>
                </msubsup>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mn>1</mn>
                  <mo>&#x2212;</mo>
                  <mfrac>
                    <msup>
                      <mi>&#x3C1;</mi>
                      <mrow>
                        <mn>2</mn>
                      </mrow>
                    </msup>
                    <mrow>
                      <mn>1</mn>
                      <mo>+</mo>
                      <mfrac>
                        <msubsup>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>&#x3B5;</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                          <mrow>
                            <mn>2</mn>
                          </mrow>
                        </msubsup>
                        <msubsup>
                          <mi>&#x3C3;</mi>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                          <mrow>
                            <mn>2</mn>
                          </mrow>
                        </msubsup>
                      </mfrac>
                    </mrow>
                  </mfrac>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font5" style="text-align:left;  font-weight: bold;">Part III. A simple take-home summary
          </p>
          <!-- <p class="font4"  style="text-align:left; font-weight: bold;">A simple take-home summary</p> -->
          <br>
          <p class="font1" style="text-align:left; ">Despite the rather complex statistical basis, HEC is <i
              style="font-weight: bold;">extremely friendly to end users</i> once a
            physically underpinned emergent constraint relation is identified.
          </p>

          <p class="font1" style="text-align:left; ">Given ensembles of current and future climate states estimated, for
            example, from the Coupled
            Model Intercomparison Projects (CMIP), suppose that the mean and standard deviation of the
            current climate estimates are <math>
              <msub>
                <mrow>
                  <mover>
                    <mi>&#x3BC;</mi>
                    <mo stretchy="false">^</mo>
                  </mover>
                </mrow>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
            </math>
            and <math>
              <msub>
                <mrow>
                  <mover>
                    <mi>&#x3C3;</mi>
                    <mo stretchy="false">^</mo>
                  </mover>
                </mrow>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
            </math>
            , those of the future climate estimates are <math>
              <msub>
                <mrow>
                  <mover>
                    <mi>&#x3BC;</mi>
                    <mo stretchy="false">^</mo>
                  </mover>
                </mrow>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
            </math>
            and
            <math>
              <msub>
                <mrow>
                  <mover>
                    <mi>&#x3C3;</mi>
                    <mo stretchy="false">^</mo>
                  </mover>
                </mrow>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                      <mo>+</mo>
                      <mi>&#x3B4;</mi>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
              </msub>
            </math> , the correlation coefficient between the ensembles of historical and future climate estimates
            is <math>
              <mrow>
                <mover>
                  <mi>&#x3C1;</mi>
                  <mo stretchy="false">^</mo>
                </mover>
              </mrow>
            </math>,
            and an observation of the current climate is <math>
              <msub>
                <mi>Y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>
            with uncertainty <math>
              <msub>
                <mrow>
                  <mover>
                    <mi>&#x3B5;</mi>
                    <mo stretchy="false">^</mo>
                  </mover>
                </mrow>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
            </math>,
            the observationally
            constrained distribution of the future climate can be expressed as
          </p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
              <msub>
                <mi>X</mi>
                <mrow>
                  <mi>t</mi>
                  <mo>+</mo>
                  <mi>&#x3B4;</mi>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mrow>
                <mo stretchy="false">|</mo>
              </mrow>
              <msub>
                <mi>Y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mo>=</mo>
              <msub>
                <mi>y</mi>
                <mrow>
                  <mi>t</mi>
                </mrow>
              </msub>
              <mo>&#x223C;</mo>
              <mrow>
                <mi mathvariant="normal">N</mi>
              </mrow>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mrow>
                    <mover>
                      <mi>&#x3BC;</mi>
                      <mo stretchy="false">^</mo>
                    </mover>
                  </mrow>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                        <mo>+</mo>
                        <mi>&#x3B4;</mi>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                </msub>
                <mo>+</mo>
                <mfrac>
                  <mrow>
                    <mrow>
                      <mover>
                        <mi>&#x3C1;</mi>
                        <mo stretchy="false">^</mo>
                      </mover>
                    </mrow>
                    <msub>
                      <mrow>
                        <mover>
                          <mi>&#x3C3;</mi>
                          <mo stretchy="false">^</mo>
                        </mover>
                      </mrow>
                      <mrow>
                        <msub>
                          <mi>X</mi>
                          <mrow>
                            <mi>t</mi>
                            <mo>+</mo>
                            <mi>&#x3B4;</mi>
                            <mi>t</mi>
                          </mrow>
                        </msub>
                      </mrow>
                    </msub>
                    <msub>
                      <mrow>
                        <mover>
                          <mi>&#x3C3;</mi>
                          <mo stretchy="false">^</mo>
                        </mover>
                      </mrow>
                      <mrow>
                        <msub>
                          <mi>X</mi>
                          <mrow>
                            <mi>t</mi>
                          </mrow>
                        </msub>
                      </mrow>
                    </msub>
                  </mrow>
                  <mrow>
                    <msubsup>
                      <mrow>
                        <mover>
                          <mi>&#x3C3;</mi>
                          <mo stretchy="false">^</mo>
                        </mover>
                      </mrow>
                      <mrow>
                        <msub>
                          <mi>X</mi>
                          <mrow>
                            <mi>t</mi>
                          </mrow>
                        </msub>
                      </mrow>
                      <mrow>
                        <mn>2</mn>
                      </mrow>
                    </msubsup>
                    <mo>+</mo>
                    <msubsup>
                      <mrow>
                        <mover>
                          <mi>&#x3C3;</mi>
                          <mo stretchy="false">^</mo>
                        </mover>
                      </mrow>
                      <mrow>
                        <msub>
                          <mi>&#x3B5;</mi>
                          <mrow>
                            <mi>t</mi>
                          </mrow>
                        </msub>
                      </mrow>
                      <mrow>
                        <mn>2</mn>
                      </mrow>
                    </msubsup>
                  </mrow>
                </mfrac>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <msub>
                    <mi>y</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                  <mo>&#x2212;</mo>
                  <msub>
                    <mrow>
                      <mover>
                        <mi>&#x3BC;</mi>
                        <mo stretchy="false">^</mo>
                      </mover>
                    </mrow>
                    <mrow>
                      <msub>
                        <mi>X</mi>
                        <mrow>
                          <mi>t</mi>
                        </mrow>
                      </msub>
                    </mrow>
                  </msub>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo>,</mo>
                <msubsup>
                  <mrow>
                    <mover>
                      <mi>&#x3C3;</mi>
                      <mo stretchy="false">^</mo>
                    </mover>
                  </mrow>
                  <mrow>
                    <msub>
                      <mi>X</mi>
                      <mrow>
                        <mi>t</mi>
                        <mo>+</mo>
                        <mi>&#x3B4;</mi>
                        <mi>t</mi>
                      </mrow>
                    </msub>
                  </mrow>
                  <mrow>
                    <mn>2</mn>
                  </mrow>
                </msubsup>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mn>1</mn>
                  <mo>&#x2212;</mo>
                  <mfrac>
                    <msup>
                      <mrow>
                        <mover>
                          <mi>&#x3C1;</mi>
                          <mo stretchy="false">^</mo>
                        </mover>
                      </mrow>
                      <mrow>
                        <mn>2</mn>
                      </mrow>
                    </msup>
                    <mrow>
                      <mn>1</mn>
                      <mo>+</mo>
                      <mfrac>
                        <msubsup>
                          <mrow>
                            <mover>
                              <mi>&#x3C3;</mi>
                              <mo stretchy="false">^</mo>
                            </mover>
                          </mrow>
                          <mrow>
                            <msub>
                              <mi>&#x3B5;</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                          <mrow>
                            <mn>2</mn>
                          </mrow>
                        </msubsup>
                        <msubsup>
                          <mrow>
                            <mover>
                              <mi>&#x3C3;</mi>
                              <mo stretchy="false">^</mo>
                            </mover>
                          </mrow>
                          <mrow>
                            <msub>
                              <mi>X</mi>
                              <mrow>
                                <mi>t</mi>
                              </mrow>
                            </msub>
                          </mrow>
                          <mrow>
                            <mn>2</mn>
                          </mrow>
                        </msubsup>
                      </mfrac>
                    </mrow>
                  </mfrac>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p class="font1" style="text-align:left; ">It is evident that the efficiency of an observational “constraint”
            in reducing uncertainty of the
            projected future climate is determined by factors of <math>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>&#x3B5;</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <mrow>
                <mo>/</mo>
              </mrow>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
            </math>
            and <i>ρ</i>. The former represents the
            observation error relative to the model uncertainty of current climate estimates, while the latter
            represents the strength of the emergent constraint relationship as simulated in climate models.
            Smaller values of <math>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>&#x3B5;</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <mrow>
                <mo>/</mo>
              </mrow>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
            </math>
            and stronger emergent correlations <i>ρ</i> produce more powerful constraints,
            leading to more variance reduction in the projected future climate.

          </p>
          <p class="font1" style="text-align:left; ">Figure 1 shows the reduction of projection variance as a function
            of the variance ratio <math>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>&#x3B5;</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
              <mrow>
                <mo>/</mo>
              </mrow>
              <msubsup>
                <mi>&#x3C3;</mi>
                <mrow>
                  <msub>
                    <mi>X</mi>
                    <mrow>
                      <mi>t</mi>
                    </mrow>
                  </msub>
                </mrow>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msubsup>
            </math>
            and emergent correlation <i>ρ</i>. Evaluations suggest that, for the warming in global mean near-surface
            air temperature projected by climate models participitating in the latest fifth and sixth phases of
            CMIP, the projection variance reduction would be about 50% if using the past global warming
            trend as an observational constraint.
          </p>
          <br>
          <div class="scrolldiv" style="text-align:center">
            <img style="width: 500px;" src="ec.png">
          </div>
          <br>
          <p class="font1" style="text-align:left; "><strong style="font-weight: bold;">Figure 1: The reduction of
              projection variance as a function of the variance ratio
              and emergent correlation. </strong>Marked in the bottom-right corner are typical values of
            the variance ratio and emergent correlation for the projected global mean near-surface air
            temperature in contemporary climate models forced by two future emissions scenarios (i.e.,
            SSP2-4.5/RCP4.5 and SSP5-8.5/RCP8.5) when the past global warming is used as an
            observational constraint. The resulting variance reduction turns out to be about 50%.
          </p>
          <br>
          <br>
        </div>
       
        <div>
 <button 
    v-for="(button, index) in buttons" 
    :key="index"
    class="h1i" 
    :id="'button4' + (index + 1)"
    :class="[buttonID !== index + 1 ? 'buttonLeaveStyle' : 'buttonOverStyle']"
    @mouseover="buttonMouseover($event)" 
    @mouseleave="buttonMouseleave()"
    style="float:left; margin: 10px; width:200px; height: 6vh; font-size: 15px"
    @click="downloadFile(button.fileName, button.fileName)"
  >
    <a>{{ button.label }}</a>
  </button>
        </div>
         
      </div>
          
</template>

<style>

.li1 {
  display: list-item;
  width: 100%;
  margin: auto;
  text-align: justify;
  color: #222121;
  padding-bottom: 6px;
  font-size: 18px;
}

.font1 {
  font-size: 18px;
  line-height: 30px;
}

.font2 {
  font-size: 20px;
}

.font3 {
  font-size: 18px;
}

.font4 {
  font-size: 28px;
}

.font5 {
  font-size: 24px;
}

.scrolldiv {
  width: 100%;
  text-align: center;
  overflow-x: scroll;
  -ms-overflow-style: none;
  white-space: nowrap;
}

.scrolldiv::-webkit-scrollbar {
  display: none;
}

.buttonOverStyle {
  background-color: white;
  border: 2px solid #4381a9;
  color: #4381a9;

}

.buttonLeaveStyle {
  background-color: #4381a9;
  border: 2px solid white;
  color: white
}
</style>